import React, { useState } from "react";

const TextField = ({
  label,
  placeholder = "",
  type = "text",
  name,
  required = false,
  value = "",
  onChange,
  validate,
  fullWidth = true,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleFocus = () => {
    setIsFocused(true);
  };
  const handleBlur = () => {
    setIsFocused(false);
    if (validate) {
      const message = validate();
      if (message) {
        setHasError(true);
        setErrorMessage(message);
      } else {
        setHasError(false);
        setErrorMessage("");
      }
    } else if (required && !value) {
      setHasError(true);
      setErrorMessage(`${label} is required.`);
    } else {
      setHasError(false);
      setErrorMessage("");
    }
  };

  return (
    <div className={`relative mb-6 ${fullWidth ? "w-full" : "w-auto"}`}>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        placeholder={placeholder}
        required={required}
        className={`w-full h-14 px-3 py-2 text-gray-700 border ${
          hasError ? "border-red-500" : "border-gray-300"
        } rounded-lg focus:outline-none focus:ring-2 ${
          hasError ? "focus:ring-red-500" : "focus:ring-blue-500"
        } transition-all duration-200 ${value || isFocused ? "pt-5" : ""}`}
      />

      <label
        className={`absolute left-3 transition-all duration-200 ${
          isFocused || value
            ? `-top-2.5 text-xs ${
                hasError ? "text-red-500" : "text-blue-500"
              } bg-white px-1`
            : "top-4 text-gray-500"
        } pointer-events-none`}
      >
        {label}
      </label>

      {hasError &&
        <p className="text-red-500 text-xs mt-1">
          {`${label} is required.`}
        </p>
        }
    </div>
  );
};

export default TextField;
